(function () {
    'use strict';

    angular
        .module('elogbooksDirectives')
        .directive('elogsSelectSiteAssociate', function (elogsSelectSiteAssociationDirectiveFactory) {
            return elogsSelectSiteAssociationDirectiveFactory({
                templateUrl: '/modules/directives/form-elements/select-site-associate/select-site-associate.html',
                inactiveUserMessageKey: 'ASSOCIATE_USER_INACTIVE'
            });
        });
})();
